<template>
  <div class="l-time-container">
    <img class="l-clock" src="./images/clock.png" alt="" />
    <div class="l-time"> {{ time }} </div>
  </div>
</template>

<script>
export default {
  name: 'l-time',
  props: {
    time: {
      type: String
    }
  },
  data() {
    return {}
  },
  mounted() {

  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
